"use client";

export function isGagglePopupDisabled(): boolean {
  return process.env.NEXT_PUBLIC_DISABLE_GAGGLE_POPUPS === "true";
}
